import { render, staticRenderFns } from "./completions-item-offer-wrapper.vue?vue&type=template&id=1ccfc84a&scoped=true&"
import script from "./completions-item-offer-wrapper.vue?vue&type=script&lang=js&"
export * from "./completions-item-offer-wrapper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1ccfc84a",
  null
  ,true
)

export default component.exports